import Typography from '@mui/material/Typography';

export default function DrugList() {

    
return (

<Typography variant='subtitle1' sx={{pl:8}}>  

Ascorbic acid (vitamin C), combinations<br />
Ascorbic acid (vitamin C), plain<br />
abacavir<br />
abrocitinib<br />
acenocoumarol<br />
acetaminophen / caffeine / dihydrocodeine<br />
allopurinol<br />
amikacin<br />
amitriptyline<br />
amoxapine<br />
amphetamine<br />
aripiprazole<br />
aripiprazole lauroxil<br />
articaine / epinephrine<br />
atazanavir<br />
atomoxetine<br />
atorvastatin<br />
avatrombopag<br />
azathioprine<br /><br />

belinostat<br />
belzutifan<br />
brexpiprazole<br />
brivaracetam<br />
bupivacaine<br /><br />
capecitabine<br />
carbamazepine<br />
carisoprodol<br />
carvedilol<br />
celecoxib<br />
cevimeline<br />
chloroquine<br />
chlorpropamide<br />
citalopram<br />
clobazam<br />
clomipramine<br />
clopidogrel<br />
clozapine<br />
codeine<br /><br />

dabrafenib<br />
dapsone<br />
darifenacin<br />
desflurane<br />
desipramine<br />
deutetrabenazine<br />
dexlansoprazole<br />
dextromethorphan / quinidine<br />
dextromethorphan hydrobromide / bupropion hydrochloride<br />
diazepam<br />
dibekacin<br />
dolutegravir<br />
donepezil<br />
doxepin<br />
dronabinol<br /><br />

efavirenz<br />
elagolix<br />
eliglustat<br />
enflurane<br />
erdafitinib<br />
escitalopram<br />
esomeprazole<br /><br />
fesoterodine<br />
flecainide<br />
flibanserin<br />
flucloxacillin<br />
flucytosine<br />
fluorouracil<br />
fluoxetine<br />
flurbiprofen<br />
flutamide<br />
fluvastatin<br />
fluvoxamine<br />
fosphenytoin<br /><br />
galantamine<br />
gefitinib<br />
gentamicin<br />
glimepiride<br />
glipizide<br />
glyburide<br /><br />
haloperidol<br />
halothane<br />
hydrocodone<br />
hydroxychloroquine<br /><br />
ibuprofen<br />
iloperidone<br />
imipramine<br />
irinotecan<br />
isoflurane<br />
ivacaftor<br /><br />
kanamycin<br /><br />
lamotrigine<br />
lansoprazole<br />
lesinurad<br />
lidocaine / prilocaine<br />
lidocaine and tetracaine<br />
lofexidine<br />
lornoxicam<br />
lovastatin<br /><br />
mavacamten<br />
meclizine<br />
meloxicam<br />
mepivacaine<br />
mercaptopurine<br />
methoxyflurane<br />
methylene blue<br />
metoclopramide<br />
metoprolol<br />
mirabegron<br />
moviprep<br /><br />
nalidixic acid<br />
nateglinide<br />
nebivolol<br />
neomycin<br />
netilmicin<br />
nilotinib<br />
nitrofurantoin<br />
nortriptyline<br /><br />
oliceridine<br />
omeprazole<br />
ondansetron<br />
oxcarbazepine<br />
oxymetazoline and tetracaine<br /><br />
pantoprazole<br />
paromomycin<br />
paroxetine<br />
pazopanib<br />
peginterferon alfa-2a<br />
peginterferon alfa-2b<br />
pegloticase<br />
perphenazine<br />
phenprocoumon<br />
phenytoin<br />
pimozide<br />
piroxicam<br />
pitavastatin<br />
pitolisant<br />
plazomicin<br />
pravastatin<br />
primaquine<br />
propafenone<br />
propranolol<br />
protriptyline<br /><br />
quetiapine<br /><br />
rabeprazole<br />
raltegravir<br />
rasburicase<br />
ribavirin<br />
ribostamycin<br />
risperidone<br />
ropivacaine<br />
rosuvastatin<br /><br />
sacituzumab govitecan<br />
sertraline<br />
sevoflurane<br />
simvastatin<br />
siponimod<br />
sodium ascorbate<br />
sodium nitrite<br />
streptomycin<br />
succinylcholine<br />
sulfasalazine<br /><br />
tacrolimus<br />
tafenoquine<br />
tamoxifen<br />
tamsulosin<br />
tegafur<br />
tenoxicam<br />
tetrabenazine<br />
thioguanine<br />
thioridazine<br />
tobramycin<br />
tolazamide<br />
tolbutamide<br />
tolterodine<br />
toluidine blue<br />
tramadol<br />
trimipramine<br />
tropisetron<br /><br />
valbenazine<br />
venlafaxine<br />
viloxazine<br />
voriconazole<br />
vortioxetine<br /><br />
warfarin<br /><br />
zuclopenthixol<br />

</Typography>

)
}